import { CardProps, LayoutContentProps, LayoutHeaderProps, LayoutScrollerProps } from '@/models/globalModels';

import { ComingSoon } from '../global/ComingSoon';

export const LayoutHeader = ({ children }: LayoutHeaderProps) => {
  return <div className="LayoutHeader">{children}</div>;
};

export const LayoutContent = ({ children }: LayoutContentProps) => {
  return <div className={`LayoutContent `}>{children}</div>;
};

export const LayoutScroller = ({ children, withHeader }: LayoutScrollerProps) => {
  return <div className={`LayoutScroller ${withHeader ? 'withHeader' : ''}`}>{children}</div>;
};

export const Card = ({
  children,
  extraClass = '',
  extraClassHolder = '',
  title,
  loading = false,
  comingSoon = false,
  options,
}: CardProps) => {
  return (
    <div className={`Card ${extraClass} ${title ? 'CardWithTitle' : ''} ${loading ? 'loading' : ''}`}>
      {comingSoon && <ComingSoon />}
      {(title || options) && (
        <div className={`CardTitle justify-content-between d-flex ${extraClassHolder}`}>
          {title && <p className="f-proximaNova-bold f-16 mb-1">{title}</p>}
          {options && options}
        </div>
      )}
      <div className={`CardHolder ${extraClassHolder}`}>{children}</div>
    </div>
  );
};
